import PriceRuleAddEditLayout from "components/layout/PriceRuleAddEditLayout";

const AddPriceRulePage = () => <PriceRuleAddEditLayout />;

export default AddPriceRulePage;
